import React, { 
    useState, 
    useEffect 
} from 'react';
import { 
    useHistory, 
    useRouteMatch, 
    useLocation 
} from 'react-router-dom';
import { 
    Card, 
    Col, 
    Row, 
    Button, 
    OverlayTrigger, 
    Tooltip 
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import axios from 'axios';
import queryString  from 'query-string';

// componentes
import Carregador from './../../Componentes/Carregador';
import PaginacaoComponente from './../../Componentes/Paginacao';
import Parametros from './Parametros';
import Registro from './Registro';
import GerarRelatorioSeguradoras from './Parametros/GerarRelatorioSeguradoras';
import GerarRelatorioConsultaPdf from './GerarRelatorioConsultaPdf';
import GerarRelatorioConsultaExcel from './GerarRelatorioConsultaExcel';

// consulta dos clientes
export default function ClientesPagina(){

    // parametros de consulta
    const history = useHistory();
    const location = useLocation();
    const { path } = useRouteMatch();

    // variaveis
    const [parametros, alterarParametros] = useState(Object.assign({
        pagina: 1,
        data_cadastro: '',
        estado: null,
        id_plano: null,
        id_cliente_seguradora: null,
        nome_subestipulante: '',
        data_boleto_vencimento: '',
        data_boleto_a_vencer: '',
        clientes_em_atraso: 'N',
        cliente_documento_autentique_assinado: [],
        acima_data_cadastro: 'N',
        fatura_minima_anterior: 'N',
        registrosPorPagina: 10,
        ativo: ['S'],
        tipo_pessoa: ['F', 'J'],
        texto: '',
        textoGeral: 'S',
        pre_cliente: ['S', 'N'],
        responsaveis: [],
        grupos: [],
        grupos_desconsiderados: [],
        sem_emissao_ultimos_tres_meses: 'N',
        sem_emissao_ultimos_seis_meses: 'N',
        tipo_cliente: [],
        campo_vazio: '',
        possui_vigencia: 'N',
        sexo: ['M', 'F'],
        placa_veiculo: '',
        numero_apolice: ''
    }, queryString.parse(location.search, {arrayFormat: 'bracket'})));
    const [totalRegistros, atualizarTotalRegistros] = useState(0);
    const [carregando, mostrarCarregando] = useState(false);
    const [carregandoSorteio, alterarCarregandoSorteio] = useState(false);

    // variavel para armazenar dados da consulta
    const [consulta, alterarConsulta] = useState([]);

    // consulta clientes com filtros
    async function consultar(sorteio="N") {

        // ativa carregamento
        mostrarCarregando(true);

        // caso for a consulta para o sorteio
        if(sorteio === "S") alterarCarregandoSorteio(true);

        // monta o parametro da consulta
        const parametrosConsulta = Object.assign(parametros, {
            sorteio
        })

        // codifica a query para salvar no navegador
        const encodeQuery = queryString.stringify(parametrosConsulta, {
            arrayFormat: 'bracket'
        });
        
        // atualizar url
        history.replace({
            pathname: path,
            search: "?"+encodeQuery
        });

        try {

            // realiza a requisição
            const { data } = await axios.get('/clientes', {
                params: parametrosConsulta
            });

            // atualiza registros
            alterarConsulta(data.registros);

            // atualiza total de registros
            atualizarTotalRegistros(parseInt(data.totalRegistros));

        } catch(e) {
            console.error(e?.response);
            
            // caso seja um erro vindo do back
            if(e.response && e.response.data) {

                // resgata os erros
                const erros = e.response.data;
                
                // resgata as chaves do objeto e percorre
                Object.keys(erros).forEach((erro) => {
                    // mostra toast
                    toast(({ closeToast }) => <>
                        <div className="toast-header bg-danger text-white">
                            <strong className="mr-auto">{sorteio === "S" ? "Erro ao realizar o sorteio" : "Erro!"}</strong>
                            <button
                                onClick={closeToast}
                                className="ml-2 mb-1 close btn-outline-light outline-0"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="toast-body bg-danger text-light">
                            {erros[erro]}
                        </div>
                    </>, { autoClose: 5000 })
                });
            }
        } finally {            
            // desativa carregamento
            mostrarCarregando(false);
            alterarCarregandoSorteio(false);
        }

    }

    // reenvia notificacoes das cobranças de clientes com cobrança em aberto em relação ao fechamento
    async function reenviarNotificacoesCobranca() {

        // ativa carregamento
        mostrarCarregando(true);

        // monta parametros do reenvio da cobrança
        const parametrosReenvio = {
            ...parametros,
            pagina: null,
            registrosPorPagina: null
        }

        try {

            // reenvia email e whatsapp aos clientes
            await axios.post('/clientes/reenviarNotificacaoCobranca', {
                ...parametrosReenvio
            });

            // mostra toast
            toast(({ closeToast }) => <>
                <div className="toast-header">
                    <strong className="mr-auto">Reenviado!</strong>
                    <button
                        onClick={closeToast}
                        className="ml-2 mb-1 close btn-outline-light outline-0"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body">
                    Notificações reenviadas!
                </div>
            </>, { autoClose: 5000 })

        } catch(e) {
            console.log(e?.response);

            if (e.response && e.response.data) {

                const erros = e.response.data;

                // resgata as chaves do objeto e percorre
                Object.keys(erros).map((erro) => {

                    toast(({ closeToast }) => <>
                        <div className="toast-header bg-danger text-white">
                            <strong className="mr-auto">Erro!</strong>
                            <button
                                onClick={closeToast}
                                className="ml-2 mb-1 close btn-outline-light outline-0"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="toast-body bg-danger text-light">
                            {erros[erro]}
                        </div>
                    </>, { autoClose: 5000 })

                });
            }

        } finally {

            // desativa carregamento
            mostrarCarregando(false);

        }

    }

    // inicia a aplicação
    useEffect(() => {        
        consultar();
    }, [parametros]);

    // retorna componente
    return (
        <Row>
            <Col>
                <Card className="painel-consulta border-0 shadow-sm" >
                    <div className="card-header ">
                        <div className='d-flex'>
                            <h4 className="card-title font-weight-bolder flex-grow-1">
                                Clientes
                            </h4>
                            <div>
                                <GerarRelatorioConsultaExcel parametros={parametros} />
                                <GerarRelatorioConsultaPdf parametros={parametros} />
                                <GerarRelatorioSeguradoras />
                                <OverlayTrigger 
                                    overlay={<Tooltip>Envia sms para todos os clientes presentes na consulta atual!</Tooltip>}
                                    placement='bottom'
                                >
                                    <Button
                                        className='mr-2 rounded-circle'
                                        variant='padrao'
                                        size='sm'
                                        onClick={() => {
                                            history.push('/painel/clientes/enviar-sms-massa', {
                                                parametros
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon style={{minWidth: '13px'}} className="icone" icon={["fas", "mobile-alt"]} />
                                    </Button>
                                </OverlayTrigger>
                                <OverlayTrigger 
                                    overlay={<Tooltip>Envia whatsapp para todos os clientes presentes na consulta atual!</Tooltip>}
                                    placement='bottom'
                                >
                                    <Button
                                        className='mr-2 rounded-circle'
                                        variant='padrao'
                                        size='sm'
                                        onClick={() => {
                                            history.push('/painel/clientes/enviar-whatsapp-massa', {
                                                parametros
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon 
                                            style={{ minWidth: '13px' }} 
                                            className="icone" 
                                            icon={["fab", "whatsapp"]} 
                                        />
                                    </Button>
                                </OverlayTrigger>
                                <OverlayTrigger 
                                    overlay={<Tooltip>Envia email para todos os clientes presentes na consulta atual!</Tooltip>}
                                    placement='bottom'
                                >
                                    <Button
                                        className='rounded-circle'
                                        variant='padrao'
                                        size='sm'
                                        onClick={() => {
                                            history.push('/painel/clientes/emails-massa', {
                                                parametros
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon className="icone" icon={["fas", "mail-bulk"]} />
                                        {/* <span>Emails em massa</span> */}
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>                
                        <Parametros 
                            parametros={parametros} 
                            totalRegistros={totalRegistros}
                            carregandoSorteio={carregandoSorteio}
                            reenviarNotificacoes={reenviarNotificacoesCobranca}
                            alterarParametros={alterarParametros} 
                            sortearCliente={() => consultar("S")}
                        />
                    </div>
                    
                    <Card.Body>                        
                        <table className="table table-hover tabela">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    {(
                                        parametros.tipo_pessoa.includes('J') && 
                                        parametros.tipo_pessoa.includes('F')
                                    ) && <th>F/J</th>}
                                    <th>Nome</th>
                                    {(
                                        !parametros.tipo_pessoa.includes('J') && 
                                        parametros.tipo_pessoa.includes('F')
                                    ) && <th>Nasc.</th>}
                                    {(
                                        parametros.tipo_pessoa.includes('J') && 
                                        !parametros.tipo_pessoa.includes('F')
                                    ) && <th>Nome Fantasia</th>}
                                    <th>UF</th>
                                    <th>Cidade</th>

                                    {(parametros.tipo_pessoa.includes('J') && !parametros.tipo_pessoa.includes('F'))
                                    && <th>CNPJ</th>}
                                    {(!parametros.tipo_pessoa.includes('J') && parametros.tipo_pessoa.includes('F'))
                                    && <th>CPF</th>}
                                    {(parametros.tipo_pessoa.includes('J', 'F'))
                                    && <th>CPF/CNPJ</th>}

                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {consulta && consulta.map(registro => {
                                    const id = registro?.copia === "S" ? registro.id_cliente_original : registro.id;

                                    return (
                                        <Registro  
                                            key={`${registro.id}`} 
                                            dados={registro}
                                            parametros={parametros}
                                            onClickTr={() => history.push(`/painel/clientes/alterar/${id}`)}
                                            clicouEditar={() => history.push(`/painel/clientes/alterar/${id}`)}
                                            clicouEnviarEmail={() => history.push(`/painel/clientes/enviar-email/${id}`)}
                                            clicouEnviarSms={() => history.push(`/painel/clientes/enviar-sms/${id}`)}
                                            clicouEnviarWhatsapp={() => history.push(`/painel/clientes/enviar-whatsapp/${id}`)}
                                            clicouInativar={() => {
                                                registro.ativo = 'N';
                                                alterarConsulta([...consulta]);
                                            }}
                                            clicouAtivar={() => {
                                                registro.ativo = 'S';
                                                alterarConsulta([...consulta]);
                                            }}
                                        />
                                    )
                                })}
                            </tbody>
                        </table>
                        <PaginacaoComponente
                            pagina={parametros.pagina}
                            registrosPorPagina={parametros.registrosPorPagina}
                            totalRegistros={totalRegistros}
                            alterouPagina={(pagina) => alterarParametros({...parametros, pagina: pagina})}
                        />
                        {carregando && <Carregador className="rounded-bottom" />}
                    </Card.Body>
                    
                </Card>
            </Col>
        </Row>
    )
}